(() => {
  const mediaQuery = window.matchMedia('(max-width: 749px)');
  const videos = new Set();
  const visible = video => {
    const rect = video.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0;
  };
  const sourceFor = video => {
    if (video.dataset.r2DesktopSrc) {
      return mediaQuery.matches ? video.dataset.r2MobileSrc || video.dataset.r2DesktopSrc : video.dataset.r2DesktopSrc;
    }
    const sources = [...video.querySelectorAll('source[data-r2-src]')];
    return sources.find(source => video.canPlayType(source.type))?.dataset.r2Src || sources[0]?.dataset.r2Src;
  };
  const activate = video => {
    const source = sourceFor(video);
    if (!source) return;
    if (video.dataset.r2SelectedSrc !== source) {
      video.dataset.r2SelectedSrc = source;
      video.dataset.r2SourceStartedMs = String(performance.now());
      video.src = source;
      video.preload = 'metadata';
      video.load();
    }
    if (video.autoplay && visible(video)) video.play().catch(() => {});
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) activate(entry.target);
      else if (entry.target.autoplay) entry.target.pause();
    });
  }, {rootMargin: '240px 0px', threshold: [0, .1, .5]}) : null;
  const initialize = () => {
    document.querySelectorAll('video[data-flaskap-r2-video]').forEach(video => {
      if (videos.has(video)) return;
      videos.add(video);
      video.addEventListener('loadedmetadata', () => {
        if (video.videoWidth && video.videoHeight) video.style.aspectRatio = `${video.videoWidth} / ${video.videoHeight}`;
      });
      video.addEventListener('loadeddata', () => {
        video.dataset.r2FirstFrameLoadMs = String(Math.round(performance.now() - Number(video.dataset.r2SourceStartedMs)));
      });
      video.addEventListener('play', () => {video.dataset.r2PlayStartedMs = String(performance.now());});
      video.addEventListener('playing', () => {
        video.dataset.r2PlayToPlayingMs = String(Math.round(performance.now() - Number(video.dataset.r2PlayStartedMs)));
      });
      if (observer) observer.observe(video);
      else activate(video);
      if (visible(video)) activate(video);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  mediaQuery.addEventListener('change', () => videos.forEach(video => {if (video.dataset.r2SelectedSrc) activate(video);}));
})();
